// Manages storing data in browser's local storage and/or cookies

export default (function(w,d){

	// Internals

	var _localStorage = {
			// Local storage methods, only if localStorage is supported by the browser

			supported : function(){
				try {
					return (typeof(localStorage)!=='undefined')
				} catch(exc) {
					return false;
				}
			},
			getData : function(key){
				if(this.supported()) return (localStorage.getItem(key)?localStorage.getItem(key):false);
			},

			setData : function(key,value){

				try {
					if (this.supported()) localStorage.setItem(key, value);
				} catch(err){
					//console.log(err) // TODO: Currently silent errors
				}
			},

			// Add data to end of array
			pushData : function(key,value){
				if(!this.supported()) return false;
				var _existing = JSON.parse(this.getData(key)),
					_values = (_existing)?_existing:[];

				_values.push(""+value);

				this.setData(key,JSON.stringify(_values));

			},

			popData : function(key,value){
				if(!this.supported()) return false;
				var _values = [],
					_existing = this.getData(key);

				if(_existing){
					_.each(_existing.split(','),function(el){
						if(""+el !== ""+value) _values.push(""+el);
					});
					this.setData(key,_values);
				}


			},

			clearData : function(key){
				if(this.supported()) localStorage.removeItem(key);
			}
		},

		_cookieStorage = {
			// Cookie storage methods, used as fallback for non localStorage, longer lived and/or requests that need to go back to the server

			setData : function(key,value){
				var _key = key.replace(/\./g, '_'),
					_d = new Date(),
					_expires;

				_d.setTime(_d.getTime() + (360*24*60*60*1000));
				_expires = "expires="+_d.toGMTString();

				document.cookie = key + "=" + value + "; " + _expires;
			},

			getData : function(key){
				var _key     = key.replace(/\./g, '_'),
					_cName   = key + "=",
					_cookies = document.cookie.split(';');

				for(var i=0; i < _cookies.length; i++){
					var c = _cookies[i];
					while (c.charAt(0)===' ') c = c.substring(1);
					if (c.indexOf(_cName) !== -1) return c.substring(_cName.length,c.length);
				}

				return '';
			},

			clearData : function(key){
				var _key = key.replace(/\./g, '_'),
					_expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT";

				document.cookie = _key + "=; " + _expires;
			}
		},

	// API Methods

		getStorageKey = function(components){
			return components.join('_');
		},

	// Set the given key/value in either local storage, cookie or both
		_setData = function(key,value,where){
			var _where = where||"both";
			var _useLocal = (_where=="local"||_where=="both"),
				_useCookie = (_where=="cookie"||_where=="both");

			try {
				if(_useLocal) _localStorage.setData(key,value);
				if(_useCookie) _cookieStorage.setData(key,value);

			} catch(err){
				//console.log(err) // TODO: currently Silent errors
			}


		},

	// Add data to end of array
		_pushData = function(key,value,where){
			var _where = where||"both";
			var _useLocal = (_where=="local"||_where=="both"),
				_useCookie = false; // (_where=="cookie"||_where=="both"); <-- Not currently supported [SG]

			if(_useLocal) _localStorage.pushData(key,value);
			if(_useCookie) _cookieStorage.pushData(key,value);

		},

		_popData = function(key,value,where){
			var _where = where||"both";
			var _useLocal = (_where=="local"||_where=="both");
			_useCookie = false; // (_where=="cookie"||_where=="both"); <-- Not currently supported [SG]

			if(_useLocal) _localStorage.popData(key,value);
			if(_useCookie) _cookieStorage.popData(key,value);
		},

		_getData = function(key){
			var _theData = _localStorage.getData(key);
			if(!_theData){
				_theData = _cookieStorage.getData(key);
			}

			return _theData;
		},

	// Clear an item from local storage and cookie
		_clearData = function(key){
			if("undefined"!==typeof(key)){
				_localStorage.clearData(key);
				_cookieStorage.clearData(key);
				return true;
			}
		};

	return {
		'get'   : _getData,
		'set'   : _setData,
		'push'  : _pushData,
		'pop'   : _popData,
		'clear' : _clearData,
		'getKey': getStorageKey
	}

}(window,document));